import React from 'react';
import { Text, useIsMobile } from '@amzn/storm-ui';
import {
  ACTION_STATE,
  BAR_STATE,
  BUTTON_TYPE,
  PopoverMultipleLines,
  PopoverWithContent,
  VALUE_STYLE,
} from './types';
import { KeyText } from './Attributes/styles';

export const MultipleLines = ({ lines }) =>
  lines?.map((line) => <Text key={line}>{line}</Text>);

export const DynamicPopover = ({
  popover,
}: {
  popover: PopoverWithContent | PopoverMultipleLines | string;
}) => {
  if (typeof popover === 'string') return <Text>{popover}</Text>;
  if ('lines' in popover) return <MultipleLines lines={popover.lines} />;
  if ('headerText' in popover)
    return (
      <>
        <Text>{popover.headerText}</Text>
        <Text>{popover.text}</Text>
        <MultipleLines lines={popover.list} />
      </>
    );
  return <Text>{JSON.stringify(popover)}</Text>;
};

export const isValidPopoverResponse = (popover) =>
  popover?.lines || popover?.headerText || popover?.list || popover?.text;

export const useFontSize = () => (useIsMobile() ? 'base' : 'small');

export const KeyLabel = ({ label }) => {
  const keyFontSize = useFontSize();
  if (!label) return null;
  return (
    <KeyText size={keyFontSize} color="secondary" inline={true} renderAs="span">
      {label}:
    </KeyText>
  );
};

export const mapButtonTypeToStormButtonVariant = (
  buttonType: BUTTON_TYPE | string,
) => {
  switch (buttonType) {
    case BUTTON_TYPE.PRIMARY:
      return 'primary';
    case BUTTON_TYPE.LINK:
      return 'link';
    case BUTTON_TYPE.NORMAL:
    default:
      return 'default';
  }
};

export const mapKeyValueStyleToStormKeyValueVariant = (
  keyValueStyle?: VALUE_STYLE,
) => {
  switch (keyValueStyle) {
    case VALUE_STYLE.SUCCESS:
      return 'success';
    case VALUE_STYLE.DISABLED:
      return 'disable';
    case VALUE_STYLE.WARNING:
      return 'warning';
    case VALUE_STYLE.ERROR:
      return 'error';
    case VALUE_STYLE.INACTIVE:
      return 'inactive';
    default:
      return 'default';
  }
};

export const mapBarStateToStormProgressIndicatorVariant = (
  state?: BAR_STATE,
) => {
  switch (state) {
    case BAR_STATE.WARNING:
      return 'warning';
    case BAR_STATE.ERROR:
      return 'error';
    case BAR_STATE.SUCCESS:
    default:
      return 'default';
  }
};

export const mapActionStateToPopoverActionState = (state?: ACTION_STATE) => {
  switch (state) {
    case ACTION_STATE.DISABLED:
      return 'disabled';
    case ACTION_STATE.LOADING:
      return 'loading';
    case ACTION_STATE.ENABLED:
    default:
      return 'active';
  }
};
